export enum PeriodReference {
    End,
    Middle,
    Begin
}